// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1si0x","footer":"ReportModalFilter_footer__3sJnL"};